import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* checkTokenUsed(action: ActionInterface): any {
  try {
    const res = yield call(Http.post, "auth/checkToken", {token: action.payload?.token});

    yield put({
      type: Constants.IS_TOKEN_USED_CHECK_SUCCESS
    })

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield put({
      type: Constants.IS_TOKEN_USED_CHECK_FAILURE
    })

    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchCheckTokenUsed() {
  yield takeEvery(Constants.IS_TOKEN_USED_CHECK_START, checkTokenUsed);
}
